export default class Header {

  constructor(el) {
    this.el = el
    this.hamburger = el.querySelector('.hamburger')
    this.menu = el.querySelector('.header--menu')
    this.nav = el.querySelector('.header--nav')
    this.heroWhite = false

    if (!this.hamburger) return

    this.bindHamburger()
    this.initHero()
  }

  initHero() {
    const hero = document.querySelector('.hero')
    if (!hero) return

    this.heroWhite = true
    this.nav.classList.add('is-white')

    const observer = new IntersectionObserver(
      ([entry]) => {
        this.heroWhite = entry.isIntersecting
        if (!this.menu.classList.contains('is-full')) {
          this.nav.classList.toggle('is-white', entry.isIntersecting)
        }
      },
      { threshold: 0.1 }
    )
    observer.observe(hero)
  }

  bindHamburger() {
    this.hamburger.addEventListener('click', () => {
      const isOpen = this.hamburger.classList.toggle('is-active')
      this.menu?.classList.toggle('is-full')

      if (isOpen) {
        this.nav.classList.add('is-white')
      } else {
        this.nav.classList.toggle('is-white', this.heroWhite)
      }
    })
  }

}
